import { render, staticRenderFns } from "./add-claims-dialog.vue?vue&type=template&id=101f4a27&scoped=true&"
import script from "./add-claims-dialog.vue?vue&type=script&lang=ts&"
export * from "./add-claims-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./add-claims-dialog.vue?vue&type=style&index=0&id=101f4a27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101f4a27",
  null
  
)

export default component.exports